{getIdsAsList, get_from_list, partitionAndSort} = require('../../utils')

module.exports = (
  $scope,
  $state,
  $stateParams,
  $q,
  $location,
  $anchorScroll,
  $timeout,
  researchRequests,
  manualWorkflowStepIterations,
  $uibModal,
  settings,
  $rootScope,
  User,
  projectPermissions,
  $window,
) ->

  $scope.User = User
  $scope.projectPermissions = projectPermissions
  $rootScope.exportControllerFormDirty = false

  $scope.userCanChangeSubjectName = User.hasPermission('workflow.can_change_subject_name', false)

  $scope.showWorkflowOutcomes = User.workflow_outcome_schema?
  $scope.openOutcomesModal = (workflow) ->
    outcomesModal = $uibModal.open({
      template:  require("../../directives/WorkflowOutcomesModal/workflow-outcomes-modal.html")
      controller: "WorkflowOutcomesController"
      resolve:
        workflow: () -> workflow
        outcomeSchema: () -> User.workflow_outcome_schema
    })

    outcomesModal.result.then((outcomes) ->
      workflow.outcomes = outcomes
      $scope.updateWorkflow(workflow)
    )


  $scope.researchRequests = partitionAndSort(researchRequests, 'workflow_step', 'order')
  researchRequestsByWorkflow = {}

  $scope.editQueryMode = false
  $scope.editingWorkflow =
    newQuery: undefined
    id: undefined

  $scope.showSummaries = false
  $scope.setShowSummaries = (showSummaries) ->
    $scope.showSummaries = showSummaries

  $scope.isAMS = () ->
    settings.ENVIRONMENT is "amsterdam"

  $scope.notApplicableSteps = (allSteps) ->
    (s in s for k, s of allSteps when s[0].not_applicable).length

  $scope.incompleteSteps = (allSteps) ->
    (s in s for k, s of allSteps when not s[0].not_applicable and not s[0].complete).length

  for key, workflow of $scope.allWorkflowSteps
    results = []
    for step in $scope.allWorkflowSteps[key]
      if step.id of $scope.researchRequests
        results.push.apply results, $scope.researchRequests[step.id]
    researchRequestsByWorkflow[key] = results

  $scope.researchRequestsByWorkflow = researchRequestsByWorkflow
  $scope.workflowStepManualIterations = partitionAndSort(manualWorkflowStepIterations, 'workflow_step', 'id')

  $scope.projectDocumentsExportURL = "/workflow/project_documents_export/#{$stateParams.projectId}/"

  # set the selected workflows and steps to undefined as they still might be set
  # and confuse the navigation
  $scope.$parent.workflow = undefined
  $scope.$parent.step = undefined
  $scope.state = $state.current.name

  $scope.savingComment = false

  $scope.addComment = () ->
    $scope.savingComment = true
    $rootScope.exportControllerFormDirty = false
    $scope.project.$update()
      .then () -> $scope.savingComment = false

  $scope.updateWorkflow = (workflow) ->
    $rootScope.exportControllerFormDirty = false
    workflow.$update()

  $scope.onFormEdit = () ->
    $rootScope.exportControllerFormDirty = true


  $scope.isEditingQuery = (workflowId) ->
    return $scope.editQueryMode && workflowId == $scope.editingWorkflow.id

  $scope.getQuery = (workflow) ->
    if workflow.query?.length > 0
      return workflow.query
    else if workflow.simple_names?.length > 0
      return workflow.simple_names[0].name
    return ''

  $scope.enableEditQueryMode = (workflow) ->
    $scope.editingWorkflow.id = workflow.id
    $scope.editingWorkflow.newQuery = $scope.getQuery(workflow)
    $scope.editQueryMode = true

  $scope.saveWorkflowQuery = (workflow) ->
    $scope.editQueryMode = false
    $scope.editingWorkflow.id = undefined
    if $scope.editingWorkflow.newQuery?.length > 0 and $scope.editingWorkflow.newQuery != workflow.query
      workflow.query = $scope.editingWorkflow.newQuery
      $scope.updateWorkflow(workflow)
      $scope.editingWorkflow.newQuery = ''

  $scope.workflowStepsCompleted = (workflow) ->
    if $scope.allWorkflowSteps and $scope.allWorkflowSteps[workflow.id]
      return (step for step in $scope.allWorkflowSteps[workflow.id] when step.complete).length

  $scope.researchRequestsCompleted = (workflow) ->
    if $scope.researchRequestsByWorkflow and $scope.researchRequestsByWorkflow[workflow.id]
      return (rr for rr in $scope.researchRequestsByWorkflow[workflow.id] when rr.completed_date).length

  $scope.scrollTo = (id) ->
    $location.hash(id)
    $anchorScroll()

  $scope.getSearchCountry = (country) ->
    if country
      return c for c in $scope.countries when c.id is country
    else
      return {name:'Global'}

  $scope.getDocsByRelevance = ( step, relevance ) ->
    stepStarredDocs = $scope.projectStarredDocs[ step.id ] || {}
    ( doc for docId, doc of stepStarredDocs when doc.relevance_type is relevance )

  $window.onbeforeunload = () ->
    if $rootScope.exportControllerFormDirty
      return "You have unsaved text changes. Are you sure you want to leave this page?"

  $scope.$on('$destroy', () ->
    $window.onbeforeunload = undefined
  )
